export default "__VITE_ASSET__CgPN2xow__"